var map = {
	"./abrasion-resistant.svg": 17181,
	"./absortion-system.svg": 17843,
	"./acoustic-insulation.svg": 18666,
	"./adaptability.svg": 23364,
	"./adjustable-desk.svg": 75335,
	"./adjustable-leg.svg": 92912,
	"./aluminium-frame.svg": 60385,
	"./anti-mould.svg": 68724,
	"./anti-stain.svg": 55570,
	"./ar.svg": 44027,
	"./av-system.svg": 80648,
	"./bleach-ok.svg": 58662,
	"./breaking-terst-300.svg": 51050,
	"./breaking-test-200kg.svg": 3769,
	"./calendaring.svg": 17252,
	"./call-117.svg": 18668,
	"./ce.svg": 83278,
	"./class-a2.svg": 47790,
	"./class-i.svg": 78492,
	"./class-ii.svg": 83037,
	"./class-iii.svg": 12622,
	"./click-and-work-system.svg": 60894,
	"./cloud-solutions.svg": 73246,
	"./do-not-wash.svg": 37171,
	"./dry-cleaning-pce.svg": 72832,
	"./durability.svg": 62347,
	"./easy-clean.svg": 49656,
	"./easy-maintenance.svg": 7798,
	"./eco-friendly.svg": 15739,
	"./energy-efficiency.svg": 18824,
	"./environmental-certified-materials.svg": 97987,
	"./fast-assembly.svg": 87745,
	"./fire-retardand.svg": 40690,
	"./folding.svg": 62605,
	"./foot-switch-on-off.svg": 20695,
	"./full-screen-mode.svg": 73522,
	"./handwash.svg": 76248,
	"./has-to-be-under-porch.svg": 66882,
	"./indoor.svg": 92827,
	"./integrated-technology.svg": 7232,
	"./internal-meetings.svg": 26688,
	"./ip-65.svg": 89713,
	"./ip.svg": 3009,
	"./iron-ok.svg": 20911,
	"./iso140012015.svg": 37391,
	"./iso90012015.svg": 13223,
	"./isolated-work.svg": 65955,
	"./led-included.svg": 31902,
	"./led.svg": 96297,
	"./local-supplier.svg": 90932,
	"./long-meetings.svg": 13007,
	"./longlife-cycle.svg": 84639,
	"./machine-wash-normal.svg": 17117,
	"./made-in-eu.svg": 54982,
	"./metal-frame.svg": 97347,
	"./modularity.svg": 27716,
	"./motion-activation.svg": 70445,
	"./movility-sensor.svg": 96420,
	"./multiple-colors.svg": 34855,
	"./multiple-sizes.svg": 94123,
	"./nfpa-260.svg": 33276,
	"./no-bleach.svg": 64933,
	"./no-dry-clean.svg": 39459,
	"./no-iron.svg": 49654,
	"./no-thumble-dry.svg": 39733,
	"./not-regular-garbage.svg": 10292,
	"./open-spaces.svg": 31022,
	"./optional-accessories.svg": 79839,
	"./optional-wheels.svg": 14727,
	"./orientable-light.svg": 81442,
	"./outdoor-resistant.svg": 38784,
	"./physical-comfort.svg": 92382,
	"./piping-options.svg": 49750,
	"./pivot-door.svg": 42883,
	"./plug-n-play.svg": 35058,
	"./polymerization-at-160.svg": 71390,
	"./premium-materials.svg": 70052,
	"./rain-sensor.svg": 31923,
	"./rain.svg": 9792,
	"./recyclable-materials.svg": 36557,
	"./regular-airflow.svg": 94677,
	"./remote-control.svg": 63312,
	"./restore-view.svg": 22070,
	"./reverse-function-control.svg": 55213,
	"./safety-glass.svg": 98983,
	"./secure-endpoint.svg": 28217,
	"./single-or-double-gazed-wall-system.svg": 60513,
	"./small-spaces.svg": 38537,
	"./snow-sensor.svg": 61370,
	"./snow.svg": 89143,
	"./sound-xx-db.svg": 18335,
	"./stackable.svg": 71986,
	"./suitable-indoor.svg": 73099,
	"./temperature-resistant.svg": 62514,
	"./thermal-welding.svg": 14612,
	"./ul.svg": 6825,
	"./unstable-table.svg": 75197,
	"./uv-resistant.svg": 52117,
	"./ventilation-system.svg": 64175,
	"./view-our-fabrics.svg": 98289,
	"./view-our-materials.svg": 50121,
	"./water-repellent.svg": 98629,
	"./wind-sensor.svg": 27827,
	"./wind.svg": 83296,
	"./with-wheel.svg": 38456,
	"./x1-to-4-people.svg": 48420,
	"./x2-to-4-people.svg": 37087,
	"./x24-volts.svg": 2703,
	"./x30-bleach-80-water.svg": 84704,
	"./x360-.svg": 57084,
	"./x4-to-6-people.svg": 91003,
	"./x40-defree-wash.svg": 46560,
	"./x6-speed-selection.svg": 96527,
	"./x6-to-8-people.svg": 58375,
	"./x60-degree-wash.svg": 44875,
	"./x8-to-10-people.svg": 23570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30601;